import * as yup from 'yup';
import { urlRegex, zipCode } from '../../../regex';

const getSchema = jurisdictions =>
  yup.object().shape({
    address: yup.string().required().label('Address'),
    street: yup.string().required().label('Street'),
    city: yup.string().required().label('City'),
    zipCode: yup
      .string()
      .matches(zipCode, 'Invalid Code number. The code number must be in format 55555 or 55555-5555')
      .required()
      .label('Zip Code'),
    jurisdictionWebsite: yup
      .string()
      .required()
      .matches(urlRegex, 'Url has a wrong format, need to start with http:// or https://')
      .label('Jurisdiction Website'),
    jurisdictions: yup
      .mixed()
      .test(
        'string-or-object',
        'Jurisdiction is required',
        value => typeof value === 'string' || (typeof value === 'object' && value !== null),
      ),
    county: yup
    .mixed().required().label('county')
    .test(
      'string-or-object',
      'County is required',
      value => typeof value === 'string' || (typeof value === 'object' && value !== null),
    ),
  });

export default getSchema;
